/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { NatsCaller } from "../NatsCaller";
import type {
  CreateSessionRequest,
  CreateSessionResponse,
  GetPresetResponse,
  ListPresetsResponse,
} from "./models";
import {
  createSessionResponseSchema,
  getPresetResponseSchema,
  listPresetsResponseSchema,
} from "./schemas";

export class NatsOnboardingClient {
  constructor(private caller: NatsCaller) {}

  async listPresets(): Promise<ListPresetsResponse> {
    const subject = "pip.${company_id}.${user_id}.rpc.onboarding.v1.presets.list";
    return await this.caller.request(subject, "listPresets", {}, listPresetsResponseSchema);
  }

  async getPreset(preset_id: string): Promise<GetPresetResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.onboarding.v1.presets.${preset_id}.get".replace(
        "${preset_id}",
        preset_id,
      );
    return await this.caller.request(subject, "getPreset", {}, getPresetResponseSchema);
  }

  async createSession(payload: CreateSessionRequest): Promise<CreateSessionResponse> {
    const subject = "pip.${company_id}.${user_id}.rpc.onboarding.v1.sessions.create";
    return await this.caller.request(
      subject,
      "createSession",
      payload,
      createSessionResponseSchema,
    );
  }
}
